import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  const specialties = ["Buyer's Agent", 'Listing Agent', 'First Time Homebuyers', 'Investment Properties', 'Military/Veterans', 'Lot/Land'];
  return <Section id="about" background="white" className="relative overflow-hidden" data-id="element-10">
      {/* Subtle background pattern */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-brand-light/50 -skew-x-12 transform translate-x-1/2 z-0" data-id="element-11" />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-12">
        {/* Image Side */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-13">
          <div className="aspect-[3/4] rounded-sm overflow-hidden shadow-2xl relative" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/jjkWssM8xEtJ6tTpdzZ7MM/donovan_real_estate.jpg" alt="Donavan Smith - Real Estate Agent" className="w-full h-full object-cover" data-id="element-15" />
            {/* Decorative border frame */}
            <div className="absolute inset-4 border border-white/30 pointer-events-none" data-id="element-16" />
          </div>
          {/* Floating Badge */}
          <div className="absolute -bottom-6 -right-6 bg-brand-gold text-white p-6 shadow-lg hidden md:block max-w-[200px]" data-id="element-17">
            <p className="font-heading font-bold text-3xl" data-id="element-18">6+</p>
            <p className="text-sm uppercase tracking-wider" data-id="element-19">
              Years of Experience
            </p>
          </div>
        </motion.div>

        {/* Text Side */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-20">
          <h4 className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-21">
            About Me
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-6" data-id="element-22">
            Meet Donavan.
          </h2>

          <div className="space-y-4 text-gray-600 leading-relaxed text-lg" data-id="element-23">
            <p data-id="element-24">
              With over 6 years of experience in the Arizona real estate market,
              I bring a unique perspective to every transaction. My background
              includes 4 years on the investment side, giving me the analytical
              expertise to help clients not just find a home, but make a smart
              financial decision.
            </p>
            <p data-id="element-25">
              Before real estate, I was a 3-sport athlete competing in football,
              basketball, and track—instilling in me a competitive drive and
              discipline that I now channel into fighting for my clients' best
              interests.
            </p>
            <p data-id="element-26">
              I'm also a passionate world traveler, having explored the cultures
              of Switzerland, Greece, Israel, and Italy. This global perspective
              helps me connect with people from all walks of life.
            </p>
          </div>

          <div className="mt-8" data-id="element-27">
            <h5 className="font-heading font-semibold text-brand-dark mb-4" data-id="element-28">
              Specialties
            </h5>
            <div className="flex flex-wrap gap-2" data-id="element-29">
              {specialties.map(item => <span key={item} className="inline-flex items-center px-3 py-1 rounded-full bg-brand-light text-brand-dark text-sm font-medium border border-gray-200" data-id="element-30">
                  <CheckCircle2 className="w-3 h-3 mr-1.5 text-brand-gold" data-id="element-31" />
                  {item}
                </span>)}
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}